"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var DialogModal_1 = __importDefault(require("@/Jetstream/DialogModal"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var InputError_1 = __importDefault(require("@/Jetstream/InputError"));
var SecondaryButton_1 = __importDefault(require("@/Jetstream/SecondaryButton"));
function JetConfirmsPassword(_a) {
    var _b = _a.title, title = _b === void 0 ? 'Confirm Password' : _b, _c = _a.content, content = _c === void 0 ? 'For your security, please confirm your password to continue.' : _c, _d = _a.button, button = _d === void 0 ? 'Confirm' : _d, onConfirm = _a.onConfirm, children = _a.children;
    var route = (0, useRoute_1.default)();
    var _e = (0, react_1.useState)(false), confirmingPassword = _e[0], setConfirmingPassword = _e[1];
    var _f = (0, react_1.useState)({
        password: '',
        error: '',
        processing: false,
    }), form = _f[0], setForm = _f[1];
    var passwordRef = (0, react_1.useRef)(null);
    function startConfirmingPassword() {
        axios_1.default.get(route('password.confirmation')).then(function (response) {
            if (response.data.confirmed) {
                onConfirm();
            }
            else {
                setConfirmingPassword(true);
                setTimeout(function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 250);
            }
        });
    }
    function confirmPassword() {
        setForm(__assign(__assign({}, form), { processing: true }));
        axios_1.default
            .post(route('password.confirm'), {
            password: form.password,
        })
            .then(function () {
            closeModal();
            setTimeout(function () { return onConfirm(); }, 250);
        })
            .catch(function (error) {
            var _a;
            setForm(__assign(__assign({}, form), { processing: false, error: error.response.data.errors.password[0] }));
            (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    }
    function closeModal() {
        setConfirmingPassword(false);
        setForm({ processing: false, password: '', error: '' });
    }
    return (react_1.default.createElement("span", null,
        react_1.default.createElement("span", { onClick: startConfirmingPassword }, children),
        react_1.default.createElement(DialogModal_1.default, { isOpen: confirmingPassword, onClose: closeModal },
            react_1.default.createElement(DialogModal_1.default.Content, { title: title },
                content,
                react_1.default.createElement("div", { className: "mt-4" },
                    react_1.default.createElement(Input_1.default, { type: "password", className: "mt-1 block w-3/4", placeholder: "Password", value: form.password, onChange: function (e) {
                            return setForm(__assign(__assign({}, form), { password: e.currentTarget.value }));
                        } }),
                    react_1.default.createElement(InputError_1.default, { message: form.error, className: "mt-2" }))),
            react_1.default.createElement(DialogModal_1.default.Footer, null,
                react_1.default.createElement(SecondaryButton_1.default, { onClick: closeModal }, "Cancel"),
                react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)('ml-2', { 'opacity-25': form.processing }), onClick: confirmPassword, disabled: form.processing }, button)))));
}
exports.default = JetConfirmsPassword;
